import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierContractNotificationsTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierContractNotificationsTranslations',
	title: 'Supplier Contract Notifications Translations',
	sanityId: 'buyeasy-supplier-contract-notifications',
	fields: {
		subscribeToAlerts: 'Subscribe to alerts',
		subscribedManage: 'Subscribed - Manage',
		manageAlerts: 'Manage alerts',
		manageAlertsDescription:
			'Select how many days before you want to get notified before important agreements with this Supplier expire so you can take action in time:',
		earliestExpiryIn: 'Earliest expiry in {numberOf} days',
		contracts: 'Contracts',
		notifyMeBefore: 'Notify me before',
		days: 'Days',
		expiresOn: 'Expires on',
		expiringIn: 'Expiring in',
		pleaseReviewUpcomingExpirations: 'Please Review: Upcoming Expirations',
		of: 'Of',
		unsubscribe: 'Unsubscribe',
		unsubscribeFromSupplier: 'Unsubscribe from Supplier?',
		yesUnsubscribe: 'Yes, unsubscribe',
		areYouSureYouWantToUnsubscribe: 'Are you sure you want to unsubscribe from this Supplier?',
		expirationDate: 'Expiration date',
		expired: 'Expired',
	},
});
